import { GUEST_LIVE_ROUTES } from '../../navigation/guestLiveAccess';

/**
 * CORE-1309 (прод 02.10.2026) — анкета «Добро пожаловать» поверх идущего эфира.
 *
 * Гость регистрируется из чата Live и возвращается в ту же комнату — а поверх
 * неё встаёт полная анкета с обложкой, фото и рассказом о себе. Обязательны из
 * неё только имя и фамилия; остальное в эфире неуместно и ждёт до профиля.
 * Поэтому в самой Live (предбанник и комната) анкета короткая.
 */
export function isCompactOnboardingRoute(route: string | undefined): boolean {
  return route != null && GUEST_LIVE_ROUTES.has(route);
}

/**
 * CORE-298 — что мешает продолжить. Кнопка без этого просто серая, и человек
 * не понимал, какое поле от него ждут. `null` — всё заполнено.
 */
export function missingRequiredHint(name: string, surname: string): string | null {
  const noName = name.trim() === '';
  const noSurname = surname.trim() === '';
  if (noName && noSurname) return 'Чтобы продолжить, укажите имя и фамилию';
  if (noName) return 'Чтобы продолжить, укажите имя';
  if (noSurname) return 'Чтобы продолжить, укажите фамилию';
  return null;
}

export type RequiredField = 'name' | 'surname';

/**
 * CORE-298 — ошибка у самого поля, а не только в футере. Подсказка под кнопкой
 * называет поле, но на телефоне с открытой клавиатурой футера не видно, и
 * человек смотрит на серую кнопку, не понимая, что от него ждут. Поле подсвечивается
 * после того, как его покинули пустым (`touched`): до этого тревожить нечем —
 * форма только открылась.
 */
export function requiredFieldError(field: RequiredField, value: string, touched: boolean): string | null {
  if (!touched || value.trim() !== '') return null;
  return field === 'name' ? 'Укажите имя' : 'Укажите фамилию';
}
